module.exports = __webpack_public_path__ + "img/Ausgehen.abc78e15.svg";